import React from 'react';
const SettingsContainer = () => {
    return <div>Settings</div>;
};

export default SettingsContainer;
